import { ShowableCartNs } from "ReactApp/Types/ShowableCartNs";
import { OrderInfoNs } from "ReactApp/Types/OrderInfoNs";
import { DomainNs } from "ReactApp/Types/DomainNs";
import { 
    makeObservable, observable, 
    computed, action, flow, autorun, observe
} from "mobx";
import { 
    DeliveryTypeEnum,
    IntegrationRecordTypeEnum,
    OrderRequestPayServiceStatusTypeEnum,
    PaymentTypeEnum, 
    ProductTypeEnum, 
    ShowableCartSourceModeEnum
} from "ReactApp/Types/enum";
import { 
    cartInstance, 
    CardCartProduct, 
    RealModifierCartProduct, 
    VirtualModifierCartProduct 
} from "ReactApp/Ddd/Aggregates/Cart";
import { CartNs } from "ReactApp/Types/CartNs";
import { ProductInfoNs } from "ReactApp/Types/ProductInfoNs";
import LIVR, { showError } from "ReactApp/Services/Validator/ValidatorInit";
import $ from 'jquery';
import Cookies from "js-cookie";
import { csrfTokenInstance } from "ReactApp/Services/CsrfToken/CsrfToken";
import { PaymentNs } from "ReactApp/Types/PaymentNs";
import { paymentInfoGenerator } from "ReactApp/Services/Generators/PaymentInfoGenerator";
import {
    MarketingEventVariableItemTypeEnum,
    MarketingEventVariableTypeEnum
} from "../../../app/frontend/assets/js/enums/MarketingEventVariableTypeEnum";
import {biMarketingEventRunnerRun} from "../../../app/frontend/assets/js/services/bi/WithBiMarketingEventRunner";
import {MarketingEventTypeEnum} from "../../../app/frontend/assets/js/enums/MarketingEventTypeEnum";
import {CurrencyTypeEnum} from "../../../app/frontend/assets/js/enums/CurrencyTypeEnum";
import OrderResponse = MarketingEventNs.OrderResponse;
import {WebSocketConnector} from "../../Services/WebSocketConnector/WebSocketConnector";
import {WebSocketChannels} from "../../Services/WebSocketConnector/WebSocketChannels";

// import { 
//     ShowableProductCardHtmlIdentifierEnum,
//     ProductTypeEnum,
//     VirtualModifierSwitcherTypeEnum,
//     PriceTypeEnum,
// } from "ReactApp/Types/enum";
// import { InvalidInitialLoadFromServerAppError } from "ReactApp/Ddd/Contracts/common";
// import { ProductInfoNs } from "ReactApp/Types/ProductInfoNs";

/**
 * On the server, it is transformed from the TODO!!! aggregate
 * @see TODO!!!
 * 
 * TODO[dependOnGuide]: docs/testing/manual-test-guides/order-request.md
 */
export class ShowableCart 
    implements ShowableCartNs.ShowableCartInterface
{
    sourceMode: ShowableCartSourceModeEnum = ShowableCartSourceModeEnum.preOrder;

    /**
     * Задержка запуска обновления данных корзины
     * (PreOrder - данные в куках до создания заказа) для предотвращения
     * накопления однотипных запросов на сервер
     */
    public updateCartTimeoutWait: number = 200;
    public updateCartTimeoutId: number | null = null;

    // TODO[needImpl]: see task docs/plans-by-release/0_9_2.md
    // searchBy: 2023-06-29:2
    resourcePreOrderUrl: string = '/cart-pre-order-data';
    orderViewUrl: string = '/cart-order/{key}';
    resourceOrderUrl: string = '/cart-order-data';
    orderIdByKeyUrl: string = '/rs/order-request/id-by-key';
    versionByIdUrl: string = '/rs/order-request/version-by-id';
    versionByKeyUrl: string = '/rs/order-request/version-by-key';
    resourceOrderId: string = '';
    createOrderUrl: string = '/rs/order-request/create';
    updateOrderUrl: string = '/rs/order-request/update';
    payOrderUrl: string = '/rs/order-request/pay';

    /**
     * Начальный статус основного метода инициализации
     * (см. метод initialize)
     */
    isCartDataLoaded: boolean = false;

    /**
     * Статус переинициализации
     * (см. метод reinitialize)
     * 
     * False = процесс НЕ ЗАПУЩЕН (начальный статус)
     * True = процесс ЗАПУЩЕН
     */
    isBeingReinitialize: boolean = false;

    /**
     * Статус обновления корзины
     * (см. метод updateCart)
     * 
     * False = процесс НЕ ЗАПУЩЕН (начальный статус)
     * True = процесс ЗАПУЩЕН
     */
    isBeingUpdateCart: boolean = false;

    isOrderIdLoaded: boolean = false;

    /**
     * Изменилась ли инкрементальная версия заказа 
     * Обратите внимание: данный флаг должен сбрасываться 
     * при любых запросах на изменение данных 
     * (payOrder/updateOrder/etc)
     */
    isOrderVersionChanged: boolean = false;

    /**
     * Общий флаг, указывающий на то, что заказ
     * находится в процессе обработки, это значит что все
     * UX-элементы интерфейса должны быть недоступны
     * до окончания процесса 
     */
    isOrderBeingProcessed: boolean = false;

    /**
     * Общий флаг, указывающий на то, что для заказа
     * запущен процесс оплаты
     */
    isOrderBeingPayed: boolean = false;

    /**
     * Флаг, указывающий на то, что клиент
     * ожидает новую версию заказа от сервера
     * (при оплате или обновлении)
     */
    isWaitingNewVersionOrder: boolean = false;

    /**
     * Статус говорящий о том, что заказ был создан
     * и запустился процесс ожидания данных от сервера
     * чтобы перенаправить клиента на странице созданного заказа
     */
    isOrderCreated: boolean = false;

    requestKey: string|null = null;

    anotherAttemptVia: number | null = null;
    timerInterval: number | null = null;
    retryTimeout: number = 5000;
    retries: number = 5;
    createOrderValidatorRules = {
        'clientInfo': {
            'nested_object': {
                'phone':  ['required', 'russian_phone']
            },
        },
        'paymentType': ['required_as_message'],
        // пока в корзине мы стараемся делать максимальное кол-во
        // необязательных полей, чтобы не "давить" на пользователя
        // в будущем, если нужны кастомные валидаторы
        // определяйте их по принципу russian_phone выше
        // (ReactApp/Services/Validator/ValidatorInit.ts)
    };
    updateOrderValidatorRules = {
        'clientInfo': {
            'nested_object': {
                'phone':  ['required', 'russian_phone']
            },
        },
    };
    createOrderValidator = new LIVR.Validator(this.createOrderValidatorRules);
    updateOrderValidator = new LIVR.Validator(this.updateOrderValidatorRules);
    orderErrors: string[] = [];
    orderErrorBlockId: string = 'cart-order-error-v1';
    // TODO[needImpl]: see task docs/plans-by-release/0_9_2.md
    // searchBy: 2023-06-29:2

    private static _instance: ShowableCart;

    dolyameMaxSum: number = 30000;
    yookassaMaxSum: number = 300000;

    // go to special components
    cards: Array<
        DomainNs.ProductCardV6Interface | 
        DomainNs.ProductCardV7Interface
    > = [];

    getCardsForMarketingEventsFormat(): Record<number, any>[] {
        return this.cards.map(card => ({
            [MarketingEventVariableItemTypeEnum.itemId]: card.articul,
            [MarketingEventVariableItemTypeEnum.itemName]: card.title,
            [MarketingEventVariableItemTypeEnum.itemVariant]: card.currentRealModifier?.label ?? null,
            [MarketingEventVariableItemTypeEnum.price]: card.salePrice?.value ?? null,
            [MarketingEventVariableItemTypeEnum.quantity]: card.cartInfo.number ?? 1,
        } as Record<number, any>));
    }

    promoInfo: CartNs.PromoInfoInterface = {
        promoCode: null,
        totalDiscountValue: null
    };

    /**
     * Виды оплат с доп. данными
     * (подключаемые скрипты/описание/порядок вывода/статус активности/etc)
     */
    payments: PaymentNs.PaymentInfoInterface[] = [];

    order: OrderInfoNs.OrderInfoInterface = {
        id: null,
        key: null,
        number: (
            this.sourceMode === ShowableCartSourceModeEnum.preOrder
                ? (Cookies.get('assignedOrderNumber') ?? null)
                : null
        ),
        formattedNumber: (
            this.sourceMode === ShowableCartSourceModeEnum.preOrder
                ? (
                    Cookies.get('assignedOrderNumber') ? 
                        ((Cookies.get('assignedOrderNumber') as string)
                            // as format: XXX-XXX
                            .padStart(6, '0').match(/.{1,3}/g)?.join('-') as string)
                        : null
                )
                : null
        ),
        clientInfo: {
            name: null,
            phone: null,
            email: null
        },
        promocode: null,
        stageType: null,
        payServiceStatusType: null,
        deliveryType: (
            this.sourceMode === ShowableCartSourceModeEnum.preOrder
                ? (
                    // для предзаказа по умолчанию доставка курьером
                    DeliveryTypeEnum.carrier
                )
                : null
        ),
        paymentType: null,
        deliveryAddress: null,
        comment: null,
        sdekPickupPoint: {
            address: null,
            id: null,
            data: null
        },
        regionName: null,
        dtCreate: null,
        dtUpdate: null,
        incrementalVersion: null,
        integrationRecords: [],
    };
    // \go to special components

    cart: CartNs.CartInterface = cartInstance;

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {

        makeObservable(this, {
            cards: observable,
            order: observable,
            createOrderValidator: observable,
            updateOrderValidator: observable,
            orderErrors: observable,
            anotherAttemptVia: observable,
            retries: observable,
            isCartDataLoaded: observable,
            isOrderBeingProcessed: observable,
            isOrderBeingPayed: observable,
            isOrderCreated: observable,
            isOrderVersionChanged: observable,
            isWaitingNewVersionOrder: observable,
            // calculated/action/flow/etc
            isSdekAvailable: computed,
            totalBaseSum: computed,
            totalDiscountSum: computed,
            totalSavingMoneySum: computed,
            totalDiscountPercent: computed,
            totalDolyamePaymentInfo: computed,
            totalYookassaPaymentInfo: computed,
            isValidPaymentType: computed,
            orderDeliveryInfo: computed,
            currentPayIntegrationRecord: computed,
            changeAnotherAttemptVia: action,
            changeRetries: action,
            changeLoadStatus: action,
            changeOrderIdLoadStatus: action,
            changeOrderVersionStatus: action,
            changeWaitingNewVersionOrderStatus: action,
            deleteCardByIndex: action,
            changeCartInfoByIndex: action,
        });

        this.payments = paymentInfoGenerator.generate();

    }

    get currentPayIntegrationRecord(): OrderInfoNs.IntegrationPayServiceRecordInterface | null
    {
        let record = this.order.integrationRecords.find(
            record => (
                record.type === IntegrationRecordTypeEnum.pay
                    &&
                record.isCurrent === true
            )
        );
        return (record as OrderInfoNs.IntegrationPayServiceRecordInterface) || null;
    }

    get orderDeliveryInfo(): OrderInfoNs.CarrierDeliveryInfoInterface | OrderInfoNs.PickupFromSdekDeliveryInfoInterface
    {
        // by default: DeliveryTypeEnum.carrier without delivery address
        let info: OrderInfoNs.CarrierDeliveryInfoInterface | OrderInfoNs.PickupFromSdekDeliveryInfoInterface = {
            deliveryType: DeliveryTypeEnum.carrier,
            deliveryAddress: null,
        };
        switch (this.order.deliveryType) {
            case DeliveryTypeEnum.carrier:
                info = {
                    deliveryType: this.order.deliveryType,
                    deliveryAddress: this.order.deliveryAddress || null,
                };
            break;
            case DeliveryTypeEnum.pickupFromSdek:
                info = {
                    deliveryType: this.order.deliveryType,
                    oppAddress: this.order.sdekPickupPoint.address || null,
                    oppId: this.order.sdekPickupPoint.id || null,
                };
            break;
        };
        return info;
    }

    get isSdekAvailable(): boolean
    {
        return (
            this.cards.filter(
                card => (
                    // хотя бы один продукт в корзине 
                    // который не может быть доставлен через СДЭК
                    card.isSdekAvailable 
                        === 
                    false
                        &&
                    // и он не удален 
                    card.cartInfo.isDeleted 
                        === 
                    false
                )
            ).length > 0
        ) ? false : true;
    }

    get isValidPaymentType(): boolean
    {
        if (this.order.paymentType === null) {
            return false;
        }
        return true;
    }

    get totalBaseSum(): number | null
    {
        let that = this;
        let acc = 0;
        that.cards.forEach(card => {
            if (
                card.cartInfo !== null
                    &&
                card.salePrice !== null 
                    &&
                card.salePrice.isGift === undefined
                    &&
                card.salePrice.isGift !== true
                    &&
                card.cartInfo.isDeleted !== true
            ) {
                // теперь в общую цену попадает либо цена после применения промо-кода
                // либо стандартная salePrice
                if (card.cartInfo.promoPrice !== null) {
                    acc = acc + (card.cartInfo.promoPrice * (card.cartInfo.number as number));
                } else {
                    acc = acc + (card.salePrice.value * (card.cartInfo.number as number));
                }
            }
        });
        return (acc === 0) ? null : acc;
    }

    get totalDiscountSum(): number | null
    {
        let that = this;
        let acc = 0;
        that.cards.forEach(card => {
            if (
                card.cartInfo !== null
                    &&
                card.oldPrice !== null 
                    &&
                card.cartInfo.isDeleted !== true
            ) {
                acc = acc + (card.oldPrice.value * (card.cartInfo.number as number));
            }
        });
        return (acc === 0) ? null : acc;
    }

    get totalSavingMoneySum(): number | null
    {
        let that = this;
        let acc = 0;
        that.cards.forEach(card => {
            if (
                card.cartInfo !== null
                    &&
                card.salePrice !== null
                    &&
                card.oldPrice !== null
                    &&
                card.cartInfo.isDeleted !== true
            ) {
                let salePrice = (card.cartInfo.promoPrice !== null) 
                    ? card.cartInfo.promoPrice 
                    : card.salePrice.value;
                acc = acc + (
                    (card.oldPrice.value * (card.cartInfo.number as number))
                        - 
                    (salePrice * (card.cartInfo.number as number))
                );
            }
        });
        return (acc === 0) ? null : acc;
    }

    get totalDiscountPercent(): number | null
    {
        let that = this;
        let percent = 0;
        if (
            that.totalSavingMoneySum !== null
                &&
            that.totalDiscountSum !== null
        ) {
            percent = Math.round((
                that.totalSavingMoneySum / that.totalDiscountSum
            ) * 100);
        }
        return (percent <= 0) ? null : percent;
    }

    get totalDolyamePaymentInfo(): PaymentNs.CreditPartInfoInterface | null
    {
        let that = this;
        if (that.totalBaseSum !== null && that.totalBaseSum <= that.dolyameMaxSum) {
            return {
                period: '2 недели',
                cost: `${Math.round(that.totalBaseSum / 4)}`,
            };
        }
        return null;
    }
    
    get totalYookassaPaymentInfo(): PaymentNs.CreditPartInfoInterface | null
    {
        let that = this;
        if (that.totalBaseSum !== null && that.totalBaseSum <= that.yookassaMaxSum) {
            return {
                period: 'месяц',
                cost: `${Math.round(that.totalBaseSum / 6)} руб.`,
            };
        }
        return null;
    }

    /**
     * После каждого обновления данных от сервера
     * (после каждого вызова метода this.fetchCardData())
     * производится проверка на определенный статус
     * OrderRequestPayService
     */
    redirectToCurrentPayService(): void
    {
        let that = this;
        if (
            that.order.payServiceStatusType === OrderRequestPayServiceStatusTypeEnum.init
                &&
            that.currentPayIntegrationRecord !== null
                &&
            that.currentPayIntegrationRecord.externalUrl !== null
        ) {
            window.location.href = that.currentPayIntegrationRecord.externalUrl;
        }
    }

    /**
     * Update all cart by transforming all products
     * 
     * @param {boolean} isStartReinitialize
     * запустить ли полную переинициализацию данных (@see this.reinitialize())
     */
    async updateCart(
        isStartReinitialize: boolean = false
    ) {
        let that = this;

        if (that.updateCartTimeoutId !== null) {
            clearTimeout(that.updateCartTimeoutId);
        }

        that.updateCartTimeoutId = setTimeout(async () => {

            if (that.cart.productSet !== null) {
                
                let newProducts: (
                    CartNs.CardCartProductInterface |
                    CartNs.RealModifierCartProductInterface
                )[] = [];
                that.cards.map(p => {
                    switch (p.type) {
                        case ProductTypeEnum.card:
                            newProducts.push(new CardCartProduct({
                                id: (p.baseCardId as number),
                                count: p.cartInfo.number || 1,
                                isDeleted: p.cartInfo.isDeleted
                            }));
                        break;
                        case ProductTypeEnum.realModifier:
                            let productData: any = {
                                id: (p.realModifierId as number),
                                count: p.cartInfo.number || 1,
                                isDeleted: p.cartInfo.isDeleted
                            };
                            if (p.virtualModifierId !== null) {
                                productData.virtualModifierId = 
                                    p.virtualModifierId;
                            }
                            newProducts.push(
                                new RealModifierCartProduct(productData)
                            );
                        break;
                    }
                });
                that.cart.productSet.products = newProducts;

                // началось обновлении корзины
                that.changeBeingUpdateCartStatus(true);

                that.cart.updateAll().finally(() => {
                    // обновление корзины завершилось
                    that.changeBeingUpdateCartStatus(false);
                    // также запускается переинициализация
                    // после обновления данных при необходимости
                    if (isStartReinitialize) {
                        that.reinitialize();
                    }
                });

            }

        }, that.updateCartTimeoutWait);
    }

    favoriteCardByIndexSwitcher(cardIndex: number): void
    {
        this.cards[cardIndex].favoriteInfo.status = 
            !this.cards[cardIndex].favoriteInfo.status;
    }

    deleteCardByIndex(cardIndex: number): void
    {
        this.cards.splice(cardIndex, 1);
        this.updateCart(true);
    }

    markAsDeletedCard(card: DomainNs.ProductCardInterface): void
    {
        card.cartInfo.isDeleted = true;
        this.updateCart(true);
    }

    markAsUndeletedCard(card: DomainNs.ProductCardInterface): void
    {
        card.cartInfo.isDeleted = false;
        this.updateCart(true);
    }

    changeCartInfoByIndex(
        cardIndex: number, 
        cartInfo: ProductInfoNs.WithCartInfoInterface
    ): void
    {
        this.cards[cardIndex].cartInfo = cartInfo;
        this.updateCart(true);
    }

    changeAnotherAttemptVia(timer: number | null): void
    {
        let that = this;
        if (timer === null) {
            that.anotherAttemptVia = null;
            that.timerInterval = null;
        } else {
            that.anotherAttemptVia = (that.retryTimeout / 1000) - timer;
        }
    }

    changeRetries(retries: number): void
    {
        this.retries = retries;
    }

    changeLoadStatus(status: boolean): void
    {
        this.isCartDataLoaded = status;
    }

    changeBeingReinitializeStatus(status: boolean): void
    {
        this.isBeingReinitialize = status;
    }

    changeBeingUpdateCartStatus(status: boolean): void
    {
        this.isBeingUpdateCart = status;
    }

    changeOrderIdLoadStatus(status: boolean): void
    {
        this.isOrderIdLoaded = status;
    }

    changeOrderVersionStatus(status: boolean): void
    {
        this.isOrderVersionChanged = status;
    }

    changeWaitingNewVersionOrderStatus(status: boolean): void
    {
        this.isWaitingNewVersionOrder = status;
    }


    /**
     * @since 0.25
     * Полная переинициализация всей корзины
     * теперь требуется при любом ее изменении
     * если установлен промо-код - т.к. правила применения
     * не могут быть разглашены и следовательно
     * получены на стороне клиента
     */
    async reinitialize(): Promise<boolean> {
        let that = this;

        // началась переинициализации корзины
        that.changeBeingReinitializeStatus(true);

        await that.fetchCartData()
            .then(stat => {
                // ...
            })
            .catch(err => {
                console.error(
                    'Повторная переинициализация корзины не удалась! Error: ' +
                    err.message 
                );
            })
            .finally(() => {
                // переинициализация корзины завершилась
                that.changeBeingReinitializeStatus(false);
            });

        return new Promise(resolve => resolve(that.isBeingReinitialize));
    }

    // TODO[needImpl]: see task docs/plans-by-release/0_9_2.md
    // searchBy: 2023-06-29:2
    async initialize(): Promise<boolean> {
        let that = this;

        let localRetries = that.retries;
        let maxRetries: number = that.retries - 1;

        while (localRetries-- > 0 && that.isCartDataLoaded === false) {
            if (localRetries === maxRetries) {
                await new Promise(resolve => {
                    document.addEventListener("DOMContentLoaded", async (event) => {
                        await that.fetchCartData(true)
                            .then(stat => {
                                that.changeLoadStatus(stat);
                            })
                            .catch(err => {
                                console.error(
                                    'The first attempt get of the created order data by requestKey is fail! Error: ' +
                                    err.message 
                                );
                            });
                        resolve(null);
                    });
                });
            } else {
                let localTimer = 0;
                that.timerInterval = setInterval(() => {
                    that.changeAnotherAttemptVia(localTimer);
                    localTimer++;
                }, 1000);
                await new Promise(resolve => {
                    setTimeout(async () => {
                        await that.fetchCartData(true)
                            .then(stat => {
                                that.changeLoadStatus(stat);
                            })
                            .catch(err => {
                                console.error(
                                    `The another [${localRetries + 1}] attempt loading ` + 
                                    `of the created order data by requestKey is fail! Error: ` +
                                    err.message 
                                );
                            });
                        resolve(null);
                    }, that.retryTimeout);
                });
                clearInterval(that.timerInterval);
                that.changeAnotherAttemptVia(null);
            }
            that.changeRetries(localRetries);
        }

        return new Promise(resolve => resolve(that.isCartDataLoaded));
    }

    async waitingOrderId(): Promise<boolean> {

        let that = this;
        let localRetries = that.retries;
        let timerInterval;

        while (localRetries-- > 0 && that.isOrderIdLoaded === false) {

            let localTimer = 0;
            timerInterval = setInterval(() => {
                localTimer++;
            }, 1000);
            await new Promise(resolve => {
                setTimeout(async () => {
                    await that.fetchOrderId()
                        .then(stat => {
                            that.changeOrderIdLoadStatus(stat);
                        })
                        .catch(err => {
                            console.error(
                                `Ошибка получения данных от сервера: ` + 
                                `(возможно заказ находится в процессе создания) ` +
                                err.message 
                            );
                        });
                    resolve(null);
                }, 1000);
            });
            clearInterval(timerInterval);

        }

        return new Promise(resolve => resolve(that.isOrderIdLoaded));
    }

    /**
     * TODO[needImpl]: до внедрения websocket или другой
     * технологии для ожидания ответа от сервера - запускаем
     * итерационное ожидание изменений от master-ноды
     * (изменение проверяется по полю this.order.incrementalVersion)
     * @param {Function | null} onSuccess callback-функция, которая будет вызвана после
     * успешного изменения версии заказа
     * @param {Function | null} onError callback-функция, которая будет вызвана после
     * всех неудачных попыток получения новой версии или ошибки в процессе
     * успешного
     * @returns 
     */
    async waitingNewVersionOrder(
        onSuccess: Function | null = null,
        onError: Function | null = null
    ): Promise<boolean> {

        let that = this;
        // 10 попыток
        let localRetries = 10;
        let status = false;

        that.isWaitingNewVersionOrder = true;

        let currentVersion = that.order.incrementalVersion;
        let newVersion = currentVersion;

        // пока версия пришедшая от master-ноды
        // равна текущей, или до максимального кол-ва попыток
        while (
            localRetries-- > 0 
                && 
            that.isWaitingNewVersionOrder === true
        ) {
            await new Promise(resolve => {
                setTimeout(async () => {
                    await that.fetchOrderVersion()
                        .then(version => {
                            newVersion = version;
                            // если новая версия стала выше
                            // то изменяется статус и запускается
                            // запрос на получение новых данных заказа 
                            if (newVersion > currentVersion) {
                                status = true;
                                if (onSuccess !== null) {
                                    onSuccess();
                                }
                                that.changeWaitingNewVersionOrderStatus(false);
                                this.reinitialize();
                            }
                        })
                        .catch(err => {
                            if (onError !== null) {
                                onError();
                            }
                            console.error(
                                `Ошибка получения данных от сервера: ` + 
                                err.message 
                            );
                        });
                    resolve(null);
                }, 1000);
            });
        }

        return new Promise(resolve => resolve(status));
    }

    /**
     * новая версия вышестоящего метода но через webSocket
     *
     * TODO[needImpl] [НЕБЕЗОПАСНО] так как сейчас все сделано обновление по id заказа сделаю пока также
     * но лучше переделать на requestKey так как будет более безопасно
     * сейчас можно просто перебирая id в адрессной строке перебрать все заказы и поменять их
     * что являтеся критически не безопасным решением.
     * т.е перебирая /cart-order/29 можно перебрать все заказы и все их поменять,
     * очень легко даже просто бота написать, который изменит все заказы очень быстро.
     * Либо можно ввести доп проверку, на какой нибудь CookieUserId но тогда надо будет
     * городить систему, восстановлниея по электронной почти этого идентификатора.
     * Вообщем надо переделать
     *
     * @param onSuccess
     * @param onError
     */
    waitingNewVersionOrderViaWebSocket(
        onSuccess: Function | null = null,
        onError: Function | null = null
    ): void {
        const ws = WebSocketConnector({
            channels: [WebSocketChannels.OrderUpdate + ':' + this.order.key],
            onMessage: (event) => {
                let data = JSON.parse(event.data);
                if (data.incrementalVersion > this.order.incrementalVersion) {
                    this.order.incrementalVersion = data.incrementalVersion;
                    if (onSuccess !== null) {
                        onSuccess();
                    }
                    this.changeWaitingNewVersionOrderStatus(false);
                    this.reinitialize();

                    // закрываем соедениене после получения данных
                    ws.close();
                }
            }
        });
    }

    prepareOrderData(): {
        [key in string]: any
    } {
        let that = this;
        let data = Object.assign(
            that.orderDeliveryInfo,
            {
                [csrfTokenInstance.name]: csrfTokenInstance.content,
                number: that.order.formattedNumber ?? null,
                clientPhone: that.order.clientInfo.phone,
                clientEmail: that.order.clientInfo.email ?? null,
                clientName: that.order.clientInfo.name ?? null,
                clientComment: that.order.comment ?? null,
                paymentType: that.order.paymentType ?? null,
                orderSum: that.totalBaseSum ?? null,
                promocode: that.promoInfo.promoCode,
                positions: that.cards.map(product => {
                    return {
                        positionTypeId: (
                            typeof product.currentVirtualModifierAsTextile !== 'undefined'
                                ? ProductTypeEnum.virtualModifier
                                : product.type
                        ),
                        positionId: (
                            typeof product.currentVirtualModifierAsTextile !== 'undefined'
                                ? product.virtualModifierId
                                : (
                                    product.type === ProductTypeEnum.realModifier
                                        ? product.realModifierId
                                        : product.baseCardId
                                )
                        ),
                        productId: product.baseCardId,
                        count: product.cartInfo.number,
                        price: (
                            // product.cartInfo.promoPrice !== null
                            //     ? (product.cartInfo.promoPrice as number)
                            //     : (product.salePrice?.value as number)
                            // в базу данных идет фактическая цена продажи продукта А
                            // на момент времени, цена после применения промо-кода
                            // фиксируется в отдельном поле (promoPrice)
                            (product.salePrice?.value as number)
                        ),
                        oldPrice: (
                            product.oldPrice?.value as number
                        ),
                        sum: (
                            // а сумма продажи считается как раз с учетом
                            // поля promoPrice
                            (
                                product.cartInfo.promoPrice !== null
                                    ? (product.cartInfo.promoPrice as number)
                                    : (product.salePrice?.value as number)
                            )
                                * 
                            (product.cartInfo.number as number)
                        ),
                        nameAtTimeOrder: product?.title,
                        realModifierLabelAtTimeOrder: product.currentRealModifier?.label ?? '',
                        virtualModifierLabelAtTimeOrder: product.currentVirtualModifierAsTextile?.textileLabel ?? '',
                        isDiscounted: product.cartInfo.isDiscounted,
                        isStaticDiscount: product.cartInfo.isStaticDiscount,
                        discountValue: product.cartInfo.discountValue,
                        promoPrice: product.cartInfo.promoPrice,
                        gifts: product.gifts.map(gift => {
                            return {
                                giftId: gift.giftRow.giftId,
                                positionTypeId: gift.giftRow.positionTypeId,
                                positionId: gift.giftRow.positionId,
                                productId: gift.giftRow.productInfo.productId,
                                count: gift.giftRow.commonCount,
                                oldPrice: gift.giftRow.productInfo.oldPrice as number,
                                nameAtTimeOrder: gift.giftRow.productInfo.title as string,
                            };
                        }),
                    };
                }),
            }
        );
        return data;
    }

    scrollToOrderErrorBlock() {
        let that = this;
        $([document.documentElement, document.body]).animate({
            scrollTop: $(`#${that.orderErrorBlockId}`).offset()?.top
        });
    }

    async payOrder(): Promise<boolean> {
        
        let that = this;
        let success: boolean = false;
        let error: Error;
        let response: Response;

        that.isOrderBeingProcessed = true;
        that.isOrderBeingPayed = true;

        const isValidForm = that.updateOrderValidator.validate(that.order);
        if (isValidForm === false) {
            let firstErrorEl: JQuery<HTMLElement> | null = 
                showError(that.updateOrderValidator, {
                    clientInfo: {
                        nestedObject: {
                            phone: {
                                fieldName: 'CartV1Form[clientPhone]'
                            }
                        }
                    }
                });
            if (firstErrorEl !== null) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: firstErrorEl.offset()?.top
                });
            }
            that.isOrderBeingProcessed = false;
            that.isOrderBeingPayed = false;
            return false;
        }

        response = await fetch(that.buildPayOrderUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(that.prepareOrderData())
        }).catch(err => error = err);

        if (response.ok === true) {
            let responseData = await response.json();
            success = responseData.status as boolean;
            that.isOrderBeingProcessed = false;
            if (success === true) {
                that.requestKey = responseData.requestKey;
                // запускается запрос на "ожидание" новой 
                // версии заказа от master-ноды
                // that.waitingNewVersionOrder(
                //     () => {
                //         that.isOrderBeingPayed = false;
                //     }
                // );
                that.waitingNewVersionOrderViaWebSocket(() => {
                    that.isOrderBeingPayed = false;
                })
            } else {
                that.orderErrors = responseData.errors as string[];
            }
            that.scrollToOrderErrorBlock();
        }
        
        return new Promise((resolve, reject) => {
            if (error) {
                that.isOrderBeingProcessed = false;
                that.orderErrors = [error.message];
                that.scrollToOrderErrorBlock();
                return reject(new Error(error.message));
            }
            if (response.ok === false) {
                that.isOrderBeingProcessed = false;
                that.orderErrors = [response.statusText];
                that.scrollToOrderErrorBlock();
                return reject(new Error(response.statusText));
            }
            resolve(success);
        });
        
    }

    async updateOrder(): Promise<boolean> {
        let that = this;
        let success: boolean = false;
        let error: Error;
        let response: Response;
        that.isOrderBeingProcessed = true;

        const isValidForm = that.updateOrderValidator.validate(that.order);
        if (isValidForm === false) {
            let firstErrorEl: JQuery<HTMLElement> | null = 
                showError(that.updateOrderValidator, {
                    clientInfo: {
                        nestedObject: {
                            phone: {
                                fieldName: 'CartV1Form[clientPhone]'
                            }
                        }
                    }
                });
            if (firstErrorEl !== null) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: firstErrorEl.offset()?.top
                });
            }
            that.isOrderBeingProcessed = false;
            return false;
        }

        response = await fetch(that.buildUpdateOrderUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(that.prepareOrderData())
        }).catch(err => error = err);

        if (response.ok === true) {
            let responseData = await response.json();
            success = responseData.status as boolean;
            that.isOrderBeingProcessed = false;
            if (success === true) {
                // запускается запрос на "ожидание" новой 
                // версии заказа от master-ноды
                // that.waitingNewVersionOrder();
                 that.waitingNewVersionOrderViaWebSocket()
            } else {
                that.orderErrors = responseData.errors as string[];
            }
            that.scrollToOrderErrorBlock();
        }
        
        return new Promise((resolve, reject) => {
            if (error) {
                that.isOrderBeingProcessed = false;
                that.orderErrors = [error.message];
                that.scrollToOrderErrorBlock();
                return reject(new Error(error.message));
            }
            if (response.ok === false) {
                that.isOrderBeingProcessed = false;
                that.orderErrors = [response.statusText];
                that.scrollToOrderErrorBlock();
                return reject(new Error(response.statusText));
            }
            resolve(success);
        });
    }

    async createOrder(): Promise<boolean> {

        let that = this;
        let success: boolean = false;
        let error: Error;
        let response: Response;

        that.isOrderBeingProcessed = true;

        const isValidForm = that.createOrderValidator.validate(that.order);
        if (isValidForm === false) {
            let firstErrorEl: JQuery<HTMLElement> | null = 
                showError(that.createOrderValidator, {
                    clientInfo: {
                        nestedObject: {
                            phone: {
                                fieldName: 'CartV1Form[clientPhone]'
                            }
                        }
                    },
                    paymentType: {
                        selector: '.input-radio-list-v1_payment-type',
                        messageReplacements: {
                            '{message}': 'Пожалуйста, выберите способ оплаты',
                        }
                    }
                });
            if (firstErrorEl !== null) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: firstErrorEl.offset()?.top
                });
            }
            that.isOrderBeingProcessed = false;
            return false;
        }

        response = await fetch(that.createOrderUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(that.prepareOrderData())
        }).catch(err => error = err);

        if (response.ok === true) {
            let responseData = await response.json();
            success = responseData.status as boolean;
            that.isOrderBeingProcessed = false;
            if (success === true) {
                that.isOrderCreated = true;
                that.requestKey = responseData.requestKey;
                // запускается запрос на "ожидание" создания
                // заказа и получения его ID 
                // для редиректа клиента на страницу заказа
                // that.waitingOrderId();
                that.listenOrderIdViaWebSocket();

            } else {
                that.orderErrors = responseData.errors as string[];
            }
            that.scrollToOrderErrorBlock();
        }
        
        return new Promise((resolve, reject) => {
            if (error) {
                that.isOrderBeingProcessed = false;
                that.orderErrors = [error.message];
                that.scrollToOrderErrorBlock();
                return reject(new Error(error.message));
            }
            if (response.ok === false) {
                that.isOrderBeingProcessed = false;
                that.orderErrors = [response.statusText];
                that.scrollToOrderErrorBlock();
                return reject(new Error(response.statusText));
            }
            resolve(success);
        });
    }

    listenOrderIdViaWebSocket(): void {

        const that = this;

        WebSocketConnector({
            // подписывается на канал.
            channels: [WebSocketChannels.OrderCreate + ':' + that.requestKey],
            onMessage: (event) => {
                try {
                    const data: OrderResponse = JSON.parse(event.data);
                    if (
                        data.clientKey === that.requestKey &&
                        data.status === "ok" &&
                        data.orderId
                    ) {
                        // редирект после отправки всех событий
                        this.purchaseMarketingEvent(data, () => {
                             window.location.href = that.orderViewUrl.replace(
                                 '{key}',
                                 String(data.clientKey)
                             );
                        })
                    }
                } catch (err) {
                    console.error("Ошибка парсинга WebSocket-сообщения:", err);
                }
            }
        });
    }


    async fetchOrderId(): Promise<boolean> {

        let that = this;
        let success: boolean = false;
        let error: Error;
        let response: Response;

        response = await fetch(that.buildRequestByKeyUrl(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).catch(err => error = err);

        if (response.ok === true) {
            // set data
            success = true;
            let json = await response.json();
            // если заказ создан - клиент перенаправляется
            // на страницу заказа
            if (json.status === true) {
                window.location.href = that.orderViewUrl.replace(
                    '{key}', json.requestKey
                );
            }
        }
        
        return new Promise((resolve, reject) => {
            if (error) {
                return reject(new Error(error.message));
            }
            if (response.ok === false) {
                return reject(new Error(response.statusText));
            }
            resolve(success);
        });
    }

    async fetchOrderVersion(): Promise<number> {

        let that = this;
        let version: number = this.order.incrementalVersion;
        let error: Error;
        let response: Response;

        response = await fetch(that.buildVersionByKeyUrl(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).catch(err => error = err);

        if (response.ok === true) {
            // set data
            let json = await response.json();
            // отправляется новая версия
            version = json.incrementalVersion;
        }
        
        return new Promise((resolve, reject) => {
            if (error) {
                return reject(new Error(error.message));
            }
            if (response.ok === false) {
                return reject(new Error(response.statusText));
            }
            resolve(version);
        });
    }

    /**
     * @param isFirstFetch флаг нужен чтобы
     * добавлять спец. параметр в url забора данных
     * По нему сервер понимает: происходит ли полная перезагрузка
     * страницы (пользователь обновил страницу в своем устройстве), 
     * либо обновление происходит программно в ReactApp
     * @returns 
     */
    async fetchCartData(isFirstFetch = false): Promise<boolean> {

        let that = this;
        let success: boolean = false;
        let error: Error;
        let response: Response;

        response = await fetch(that.buildRequestUrl(isFirstFetch), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).catch(err => error = err);

        if (response.ok === true) {
            // set data
            success = true;
            let json = await response.json();
            Object.assign(that, json);
            
            // попытка редиректа на внешний платежный
            // сервис при определенных условиях
            that.redirectToCurrentPayService();

        }
        
        return new Promise((resolve, reject) => {
            if (error) {
                return reject(new Error(error.message));
            }
            if (response.ok === false) {
                return reject(new Error(response.statusText));
            }
            resolve(success);
        });
    }

    /**
     * Метод возвращает url для забора информации
     * о новом созданном заказе по уникальному клиентскому
     * ключу
     * @returns 
     */
    buildRequestByKeyUrl(): string
    {
        let url: string = '';
        url = `${this.orderIdByKeyUrl}?key=${this.requestKey}`;
        return url;
    }

    /**
     * Метод возвращает url для забора инкрементальной
     * версии заказа от master-ноды (признак изменения заказа)
     * @returns 
     */
    buildVersionByIdUrl(): string
    {
        let url: string = '';
        url = `${this.versionByIdUrl}?requestId=${this.order.id}`;
        return url;
    }

    /**
     * Метод возвращает url для забора инкрементальной
     * версии заказа от master-ноды (признак изменения заказа)
     * @returns
     */
    buildVersionByKeyUrl(): string
    {
        let url: string = '';
        url = `${this.versionByKeyUrl}?key=${this.order.key}`;
        return url;
    }

    /**
     * Метод возвращает url для обновления заказа
     * @returns 
     */
    buildUpdateOrderUrl(): string
    {
        let url: string = '';
        url = `${this.updateOrderUrl}?requestId=${this.order.id}`;
        return url;
    }

    /**
     * Метод возвращает url для оплаты заказа
     * @returns 
     */
    buildPayOrderUrl(): string
    {
        let url: string = '';
        url = `${this.payOrderUrl}?requestId=${this.order.id}`;
        return url;
    }

    /**
     * @param isFirstFetch флаг нужен чтобы
     * добавлять спец. параметр в url забора данных
     * По нему сервер понимает: происходит ли полная перезагрузка
     * страницы (пользователь обновил страницу в своем устройстве), 
     * либо обновление происходит программно в ReactApp
     * @returns 
     */
    buildRequestUrl(isFirstFetch = false): string
    {
        let url: string = '';
        // теперь инициализация зависит от переменной
        // this.sourceMode (preOrder / order)
        switch (this.sourceMode) {
            case ShowableCartSourceModeEnum.preOrder:
                url = (
                    this.resourcePreOrderUrl + 
                    (isFirstFetch === true ? '?isFirstFetch=true' : '')
                );
            break;
            case ShowableCartSourceModeEnum.order:
                url = (
                    this.resourceOrderUrl + '/' + this.resourceOrderId
                );
            break;
        }
        return url;
    }
    // TODO[needImpl]: see task docs/plans-by-release/0_9_2.md
    // searchBy: 2023-06-29:2

    purchaseMarketingEvent(response: OrderResponse, callback = () => {}) {
        biMarketingEventRunnerRun({
            eventTypeId: MarketingEventTypeEnum.purchase,
            dynamicData: {
                [MarketingEventVariableTypeEnum.transactionId]: response.orderId,
                [MarketingEventVariableTypeEnum.affiliation]: '',
                [MarketingEventVariableTypeEnum.tax]: '',
                [MarketingEventVariableTypeEnum.shipping]: '',
                [MarketingEventVariableTypeEnum.items]: showableCartInstance.getCardsForMarketingEventsFormat(),
                [MarketingEventVariableTypeEnum.revenue]: showableCartInstance.totalBaseSum,
                [MarketingEventVariableTypeEnum.currency]: CurrencyTypeEnum.RUB,
                [MarketingEventVariableTypeEnum.value]: showableCartInstance.totalBaseSum,
            }
        }).then(
            callback
        );
    }
}

const showableCartInstance = ShowableCart.Instance;

export { showableCartInstance };